import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Uprawnienie roli',
  type: 'object',
  properties: {
    permissionId: {
      type: 'number',
      fieldRequired: true
    },
    roleId: {
      type: 'number',
      fieldRequired: true
    }
  }
};
